var map = {
	"./android-icon.svg": 2164,
	"./app-img.png": 2165,
	"./app-qr-code-bg.png": 2166,
	"./apple-icon.svg": 2167,
	"./contact-bg.png": 2168,
	"./contact-us-bg.jpg": 2169,
	"./contact-us-main-bg.webp": 2170,
	"./qr-bg.png": 2171
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2163;